const template = require('./reports.html.slim');
const validatePriceData = require('./validate_price_data.js');

angular.module('wbComponents').directive('reports', ['$rootScope', 'railsResource', '$timeout', 'Report', 'Custodian', 'Holding',
  ($rootScope, $resource, $timeout, Report, Custodian, Holding) => ({
    scope: true,
    restrict: 'E',
    templateUrl: template,

    link(scope, elem, attrs) {
      const dates = [
        'last_balanced',
        'date',
        'updated_at',
        'created_at',
        'process_date',
        'effective_date',
        'submitted_at',
        'uploaded_at',
        'last_updated',
        'last_changed_date',
      ];
      const numbers = [
        'position_quantity',
        'percentage_cash',
        'quantity',
      ];
      const currencies = [
        'current_trade_date_balance',
        'total_gains',
        'imbalance',
        'price',
        'rts_equity',
        'calc_rts_equity',
        'total_value',
        'total_deposits',
        'total_withdrawals',
        'fees',
        'calculated_total_value',
        'spread',
        'total',
        'inflow',
        'outflow',
        'amount_value',
        'amount',
        'fee',
        'tax',
        'Opening AUM',
        'Contributions',
        'Total initial deposits',
        'Total deposits',
        'Contributions households under 6 months',
        'Contributions households over 6 months',
        'Redemptions',
        'Total deposits clients less than 6 months',
        'Total deposits clients more than 6 months',
        'Total withdrawals',
        'Ending AUM',
        'Average client AUM',
        'Average account AUM',
        'Median client AUM',
        'Median account AUM',
        'Management fee revenue',
      ];
      const percentages = [
        'percentage_government_bonds',
        'percentage_us_equities',
        'percentage_canadian_equities',
        'percentage_international_equities',
        'equities_current_allocation',
        'fixed_income_current_allocation',
        'alternatives_current_allocation',
        'cash_current_allocation',
        'equities_target_allocation',
        'fixed_income_target_allocation',
        'alternatives_target_allocation',
        'cash_target_allocation',
        'equities_deviation',
        'fixed_income_deviation',
        'alternatives_deviation',
        'cash_deviation',
        'allowable_bac_deviation_range',
        'mer',
      ];

      const show_dashes = [
        'minimum_initial_investment',
        'risk_score',
      ];

      scope.custodians = Custodian.query();
      scope.custodian = 2; // VB
      scope.mode = 'latest_cash_balances';
      scope.appStatus = 'submitted';
      scope.transferActiveStatus = 'all';
      scope.csvdata = [];
      scope.reportDate = moment().format('YYYY-MM-DD');
      scope.endDate = moment().format('YYYY-MM-DD');
      scope.startDate = moment().format('YYYY-MM-DD');
      scope.calendarEndDate = moment().format('YYYY-MM-DD');
      scope.allTime = false;
      scope.channel = 'all';
      scope.partnerChannel = 'all';
      scope.showVerticalTable = false;
      scope.showAllClients = false;
      scope.includeUnlinked = false;
      scope.etfOnly = false;
      scope.rebalance = false;
      scope.rrifLifOnly = false;
      scope.dntOnly = false;
      scope.ignoreKyc = false;
      scope.transpose = false;
      scope.minimumAccountValue = 1000;
      scope.minimumCashBalance = 100;
      scope.searchEmail = '';
      scope.includeClosedAccounts = false;

      scope.$watch('mode', (mode) => {
        if (scope.mode === 'virtual_brokers_efts') {
          const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
          scope.calendarEndDate = yesterday;
          scope.reportDate = yesterday;
        } else {
          scope.calendarEndDate = moment().format('YYYY-MM-DD');
          scope.reportDate = moment().format('YYYY-MM-DD');
        }
      });

      Report.query({}, modeList => { scope.modes = modeList; });

      scope.fieldType = (field) => {
        if (currencies.indexOf(field) >= 0) {
          return 'currency';
        } else if (dates.indexOf(field) >= 0) {
          return 'date';
        } else if (numbers.indexOf(field) >= 0) {
          return 'number';
        } else if ([ 'url', 'link', 'transfer_url', 'client_kyc_url' ].includes(field)) {
          return 'url';
        } else if (percentages.indexOf(field) >= 0) {
          return 'percentage';
        } else if (show_dashes.indexOf(field) >= 0) {
          return 'show_dash';
        }
      };

      scope.exportServer = () => {
        scope.emailedTo = false;
        scope.priceDataErrorMessage = null;

        if (scope.priceData) {
          const csvAnalysisErrors = validatePriceData(scope.priceData);
          if (csvAnalysisErrors) {
            scope.priceDataErrorMessage = csvAnalysisErrors;
            return;
          }
        }

        const args = {
          email: true,
          alias: scope.mode,
          custodian: scope.custodian,
          holding: scope.holding,
          status: scope.appStatus,
          activeStatus: scope.transferActiveStatus,
          limit: scope.limit,
          reportDate: scope.reportDate,
          data: scope.priceData,
          minimumAccountValue: scope.minimumAccountValue,
          minimumCashBalance: scope.minimumCashBalance,
          start_date: scope.startDate,
          end_date: scope.endDate,
          all_time: scope.allTime,
          active: true,
          calculated: true,
          etfOnly: scope.etfOnly,
          rebalance: scope.rebalance,
          rrifLifOnly: scope.rrifLifOnly,
          dntOnly: scope.dntOnly,
          ignoreKyc: scope.ignoreKyc,
          channel: scope.channel,
          partnerChannel: scope.partnerChannel,
          transpose: scope.transpose,
          search_email: scope.searchEmail,
          include_closed_accounts: scope.includeClosedAccounts,
          show_all_clients: scope.showAllClients,
          include_unlinked: scope.includeUnlinked,
        };
        Report.create(args).$promise.then((response) => {
          scope.error = false;
          scope.emailedTo = response.email;
          scope.csvdata = null;
          scope.data = null;
        }).catch(() => {
          scope.error = true;
          scope.emailedTo = false;
        });
      };

      scope.analyze = () => {
        scope.emailedTo = false;
        scope.loading = true;
        scope.data = null;
        scope.headers = null;
        const args = {
          alias: scope.mode,
          custodian: scope.custodian,
          holding: scope.holding,
          status: scope.appStatus,
          activeStatus: scope.transferActiveStatus,
          limit: scope.limit,
          reportDate: scope.reportDate,
          data: scope.priceData,
          minimumAccountValue: scope.minimumAccountValue,
          minimumCashBalance: scope.minimumCashBalance,
          start_date: scope.startDate,
          end_date: scope.endDate,
          all_time: scope.allTime,
          active: true,
          calculated: true,
          etfOnly: scope.etfOnly,
          rebalance: scope.rebalance,
          rrifLifOnly: scope.rrifLifOnly,
          dntOnly: scope.dntOnly,
          ignoreKyc: scope.ignoreKyc,
          channel: scope.channel,
          partnerChannel: scope.partnerChannel,
          search_email: scope.searchEmail,
          include_closed_accounts: scope.includeClosedAccounts,
          showAllClients: scope.showAllClients,
          includeUnlinked: scope.includeUnlinked,
        };
        return Report.create(args).$promise.then((response) => {
          scope.error = false;
          scope.csvdata = null;
          if (response.report) {
            const responseData = JSON.parse(response.data);
            if ((responseData !== null) && (responseData.length > 0)) {
              scope.headers = _.map(Object.keys(responseData[0]), header => ({
                value: header,
                name: _.startCase(header),
              }));
            }
            scope.data = responseData || [];
          }
          scope.loading = false;
        }).catch(() => {
          scope.error = true;
          scope.loading = false;
        });
      };

      scope.headerSort = (column) => {
        scope.sortType = column;
        scope.sortReverse = !scope.sortReverse;
      };

      scope.sortColumn = (object) => {
        const candidate = object[scope.sortType];
        if (moment(candidate, 'YYYY-M-DTH:m:s.SSSZ', true).isValid()) {
          return moment(candidate, 'YYYY-M-DTH:m:s.SSSZ', true).unix();
        } else if (isNaN(candidate) || (candidate === false) || (candidate === true)) {
          return candidate;
        } else {
          return parseFloat(candidate);
        }
      };

      scope.setReportDate = value => { scope.reportDate = value; };

      scope.hideCustodian = mode => [
        'account_applications',
        'account_kyc',
        'active_recurring_deposits_and_withdrawals',
        'aml_risk_unregistered_accounts_overview',
        'attestation',
        'aum_breakdown',
        'ceo_dashboard',
        'ci_all_positions_as_of',
        'ci_all_transactions_between',
        'early_withdrawal',
        'empty_accounts_with_active_transfers',
        'enhanced_eft',
        'fatca_crs_annual_filing',
        'healed_with_errors_or_warnings',
        'holding',
        'inactive_accounts',
        'internal_account_transactions',
        'large_cad_value_changes',
        'missing_foreign_tin',
        'partner_channel',
        'performance',
        'portfolio_models',
        'portfolio_models_breakdown_by_portfolios',
        'ppi_valet_wholesaler_billing',
        'refunds',
        'regulatory_disclosures',
        'residency',
        'restricted_countries',
        'savings_account_rate_history',
        'system_access',
        'transfer_requests',
        'transfer_requests_in_progress',
        'user_audits',
        'wealthie_client_account_numbers',
        'client_profile_changes',
      ].includes(mode);

      scope.showActiveStatus = mode => ['transfer_requests'].includes(mode);

      scope.showCusip = mode => ['holding', 'holding_archived'].includes(mode);

      scope.showStartEndDate = mode => [
        'account_applications',
        'account_kyc',
        'buy_sell',
        'ceo_dashboard',
        'internal_account_transactions',
        'partner_channel',
        'performance',
        'ppi_valet_wholesaler_billing',
        'transactions',
        'transfer_requests',
        'transfers',
        'wealthie_client_account_numbers',
        'client_profile_changes',
      ].includes(mode);

      scope.showDate = mode => [
        'aml_risk_unregistered_accounts_overview',
        'aum_breakdown',
        'ci_all_positions_as_of',
        'ci_all_transactions_between',
        'enhanced_eft',
        'trading',
        'trading_wip',
      ].includes(mode);

      scope.showAllTime = mode => [
        'account_kyc'
      ].includes(mode);

      scope.showIncludeClosedAccounts = mode => [
        'account_kyc'
      ].includes(mode);

      scope.showShowAllClients = mode => [
        'attestation'
      ].includes(mode);

      scope.showIncludeUnlinked = mode => [
        'attestation',
      ].includes(mode);

      scope.onModeChange = mode => {
        if (mode !== 'account_kyc') {
          scope.allTime = false;
          scope.includeClosedAccounts = false;
        }
      }

      scope.showEmail = mode => [
        'client_profile_changes',
      ].includes(mode);

      // trading reports controls
      scope.showTrading = mode => [
        'trading',
        'trading_wip',
      ].includes(mode);

      scope.showChannel = mode => mode === 'ceo_dashboard';

      scope.showPartnerChannel = mode => mode === 'partner_channel';

      scope.disableFilters = mode => [
        'aml_risk_unregistered_accounts_overview',
        'aum_breakdown',
        'early_withdrawal',
        'empty_accounts_with_active_transfers',
        'enhanced_eft',
        'fatca_crs_annual_filing',
        'healed_with_errors_or_warnings',
        'holding',
        'inactive_accounts',
        'internal_account_transactions',
        'missing_foreign_tin',
        'performance',
        'ppi_valet_wholesaler_billing',
        'regulatory_disclosures',
        'restricted_countries',
        'savings_account_rate_history',
        'system_access',
        'user_audits',
        'wealthie_client_account_numbers',
      ].includes(mode);

      scope.toggleTradingDntOnly = () => {
        if (scope.dntOnly === true) {
          scope.dntOnly = false;
        } else {
          return;
        }

        scope.tradingDntOnlyConfirmationDialog.show();
      };

      scope.onTradingDntOnlyConfirmationDialogConfirm = () => {
        scope.dntOnly = true;
        scope.tradingDntOnlyConfirmationDialog.hide();
      };

      scope.toggleTradingIgnoreKyc = () => {
        if (scope.ignoreKyc === true) {
          scope.ignoreKyc = false;
        } else {
          return;
        }

        scope.tradingIgnoreKycConfirmationDialog.show();
      };

      scope.onTradingIgnoreKycConfirmationDialogConfirm = () => {
        scope.ignoreKyc = true;
        scope.tradingIgnoreKycConfirmationDialog.hide();
      };
    },
  }),
]);
